var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBuilt({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 26,
    viewBox: "0 0 24 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.005 24.9999H4.99805V6.45349V1H9.005V24.9999Z",
    stroke: "#55489E",
    strokeWidth: 1.92,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.00195 6.45349H22.9985V5.36052L9.00543 1H4.99847L1.00195 5.36052V6.45349Z",
    stroke: "#55489E",
    strokeWidth: 1.92,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24 25H0",
    stroke: "#55489E",
    strokeWidth: 1.92,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.995 6.45355V10.3131C20.9839 10.686 21.0653 11.0553 21.2306 11.382C21.3959 11.7086 21.639 11.9805 21.9341 12.1689C22.2477 12.3479 22.5122 12.6144 22.7008 12.9413C22.8893 13.2681 22.9951 13.6436 23.0075 14.0295C23.0198 14.4154 22.9382 14.798 22.771 15.1384C22.6038 15.4787 22.357 15.7647 22.0556 15.9671C21.7542 16.1696 21.409 16.2813 21.0552 16.291C20.7014 16.3006 20.3515 16.2078 20.0412 16.022C19.731 15.8362 19.4714 15.564 19.2888 15.2332C19.1062 14.9023 19.0073 14.5247 19.002 14.1385",
    stroke: "#55489E",
    strokeWidth: 1.92,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.005 18.4536L4.99805 22.8255",
    stroke: "#55489E",
    strokeWidth: 1.92,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.99805 13L9.005 17.3605",
    stroke: "#55489E",
    strokeWidth: 1.92,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9.005 7.54645L4.99805 11.907",
    stroke: "#55489E",
    strokeWidth: 1.92,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuilt);
export default __webpack_public_path__ + "static/media/built.848998e3.svg";
export { ForwardRef as ReactComponent };